import { render, staticRenderFns } from "./UpEstablishment.vue?vue&type=template&id=c28ca7f2&scoped=true&slot-scope=scope&"
import script from "./UpEstablishment.vue?vue&type=script&lang=js&"
export * from "./UpEstablishment.vue?vue&type=script&lang=js&"
import style0 from "./UpEstablishment.vue?vue&type=style&index=0&id=c28ca7f2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28ca7f2",
  null
  
)

export default component.exports